export const types = {
  SET_BRANDING: "SET_BRANDING",
  UPDATE_BRANDING: "UPDATE_BRANDING",
};

export const setBranding = payload => ({
  type: types.SET_BRANDING,
  payload,
});

export const updateBranding = payload => ({
  type: types.UPDATE_BRANDING,
  payload,
});
